import moment from 'moment';

export const getTimestampAtStartOfDayUTC = (timestamp: number) => {
  const date = new Date(timestamp * 1000);
  const date_utc = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  );
  const startOfDay = Number(new Date(date_utc));
  const endTimestamp = startOfDay / 1000;
  return Math.floor(endTimestamp / 86400) * 86400;
};

export const UNIX_DAY = 86400;
export const SECONDS_PER_MIN = 60;
export const SECONDS_IN_A_YEAR = 31_536_000;

export const getTimestampAtStartOfMonth = (timestamp: number) => {
  const date = new Date(timestamp);
  const firstDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1);
  return firstDay.valueOf();
};

export const getTimestampAtStartOfNextMonth = (timestamp: number) => {
  const date = new Date(timestamp);
  const firstDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 1);
  return firstDay.valueOf();
};

export const getTimestampAtStartOfNextWeek = (timestamp: number) => {
  const date = new Date(timestamp);
  const firstDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + 7);
  return firstDay.valueOf();
};

export const getTimestampAtStartOfNextDay = (timestamp: number, interval = 1) => {
  const date = new Date(timestamp);
  const firstDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + 1 * interval);
  return firstDay.valueOf();
};

export const getTimestampAtStartOfNextHour = (timestamp: number, interval = 1) => {
  const date = new Date(timestamp);
  const firstDay = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours() + 1 * interval,
  );
  return firstDay.valueOf();
};

export const getDifferenceInMonths = (timestampStart: number, timestampEnd: number) => {
  const dateTo = new Date(timestampEnd);
  const dateFrom = new Date(timestampStart);

  return dateTo.getMonth() - dateFrom.getMonth() + 12 * (dateTo.getFullYear() - dateFrom.getFullYear());
};

export const calculateRemainingTime = (endingTimestamp: number) => {
  const now = moment(new Date());

  const remainingTime = moment.duration(moment(endingTimestamp * 1000).diff(now));

  const remainingDays = remainingTime.asDays() < 0 ? 0 : Math.floor(remainingTime.asDays());
  const remainingHours = remainingTime.hours() < 0 ? 0 : remainingTime.hours();
  const remainingMins = remainingTime.minutes() < 0 ? 0 : remainingTime.minutes();

  return `${remainingDays}D ${remainingHours}H ${remainingMins}M`;
};
